export default __webpack_public_path__ + "static/media/11.84ddf2d9.png";